const steps = [
  { number: "01", label: "Choose your palette", detail: "Pick two or three tones within the same warm neutral family — ivory, oat, and sand is a reliable starting point. No more than three." },
  { number: "02", label: "Mix the textures", detail: "At least two different materials: smooth linen with boucle, or woven cotton with velvet. Same palette, different surfaces." },
  { number: "03", label: "Vary the sizes", detail: "Large at the back (60x60cm), medium in the middle (45x45cm), lumbar at the front (30x50cm). Layer from back to front." },
  { number: "04", label: "Invest in the inserts", detail: "Feather-down inserts make every cover look better. Buy them once and swap covers as your taste evolves." },
  { number: "05", label: "Chop and relax", detail: "Fold each pillow in half and press the centre to create a natural slouch. Avoid the stiff, perfectly upright hotel look." },
];

export default function TPFormula() {
  return (
    <section className="max-w-2xl mx-auto px-4 md:px-0 py-16 mb-8">
      <p className="text-[#B5A898] text-[10px] tracking-[0.45em] uppercase mb-4" style={{ fontFamily: "'Inter', sans-serif" }}>The Formula</p>
      <h2 className="text-[#2C2825] text-2xl md:text-3xl leading-snug mb-6" style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}>
        How to Build a Perfect Pillow Arrangement in 5 Steps
      </h2>
      <div className="w-12 h-px bg-[#C8BAA8] mb-12" />
      <div className="space-y-8">
        {steps.map((step) => (
          <div key={step.number} className="flex gap-8 items-start">
            <span className="text-[#EDE6DA] text-3xl md:text-4xl flex-shrink-0 leading-none" style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}>{step.number}</span>
            <div>
              <p className="text-[#2C2825] text-sm mb-2" style={{ fontFamily: "'Inter', sans-serif", fontWeight: 500 }}>{step.label}</p>
              <p className="text-[#6B5E53] text-sm leading-relaxed" style={{ fontFamily: "'Inter', sans-serif", fontWeight: 300 }}>{step.detail}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
